
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanyDetailsContextResponse,
  CompanyDetailsForUserResponse,
  UserDetailsContextResponse,
} from '../models';
import {
    CompanyDetailsContextResponseFromJSON,
    CompanyDetailsContextResponseToJSON,
    CompanyDetailsForUserResponseFromJSON,
    CompanyDetailsForUserResponseToJSON,
    UserDetailsContextResponseFromJSON,
    UserDetailsContextResponseToJSON,
} from '../models';

export interface GetCompanyDetailsForUserRequest {
    identityId: string;
}

/**
 * 
 */
export class ClientSignupContextApi extends runtime.BaseAPI {

    /**
     * Get company-related details for the connected user (typically for the \"missing company details\" screen)
          */
    async getCompanyDetailsForUserRaw(requestParameters: GetCompanyDetailsForUserRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyDetailsForUserResponse>> {
        if (requestParameters['identityId'] == null) {
            throw new runtime.RequiredError(
                'identityId',
                'Required parameter "identityId" was null or undefined when calling getCompanyDetailsForUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyDetailsForUserResponse>({
            path: `/signup-client/api/company-details-for-user/{identityId}`.replace(`{${"identityId"}}`, encodeURIComponent(String(requestParameters['identityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyDetailsForUserResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get company-related details for the connected user (typically for the \"missing company details\" screen)
          */
    async getCompanyDetailsForUser(requestParameters: GetCompanyDetailsForUserRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyDetailsForUserResponse> {
        const response = await this.getCompanyDetailsForUserRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get details to use for the \"company details\" screen
          */
    async getContextForCompanyDetailsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyDetailsContextResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyDetailsContextResponse>({
            path: `/signup-client/api/company-details-context`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyDetailsContextResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get details to use for the \"company details\" screen
          */
    async getContextForCompanyDetails(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyDetailsContextResponse> {
        const response = await this.getContextForCompanyDetailsRaw(initOverrides);
        return response._data;
    }

    /**
     * Get details to use for the \"user details\" screen
          */
    async getContextForUserDetailsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UserDetailsContextResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UserDetailsContextResponse>({
            path: `/signup-client/api/user-details-context`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UserDetailsContextResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get details to use for the \"user details\" screen
          */
    async getContextForUserDetails(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UserDetailsContextResponse> {
        const response = await this.getContextForUserDetailsRaw(initOverrides);
        return response._data;
    }

}
